import React from "react";

export function ScheduleActions() {
	return (
		'Schedule Actions'
	)
}
